import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createVNode as _createVNode, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue";
const _hoisted_1 = { class: "relative" };
const _hoisted_2 = ["value", "placeholder"];
import componentI18n from '@/i18n/componentI18n';
const __default__ = {
    ...componentI18n('components.search_input')
};
import SvgIcon from '@/components/SvgIcon.vue';
export default /*#__PURE__*/ _defineComponent({
    ...__default__,
    __name: 'SearchInput',
    props: {
        search: null
    },
    emits: ['update:search'],
    setup(__props, { emit }) {
        const cancelSearch = () => {
            emit('update:search', '');
        };
        const handleInput = (event) => {
            emit('update:search', event.target.value);
        };
        return (_ctx, _cache) => {
            const _component_transition_a11y = _resolveComponent("transition-a11y");
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("input", {
                    class: "w-full pr-8 form-input",
                    value: __props.search,
                    type: "text",
                    autocomplete: "off",
                    placeholder: _ctx.$t('search'),
                    onInput: handleInput
                }, null, 40, _hoisted_2),
                _createVNode(_component_transition_a11y, { class: "absolute w-5 h-5 text-primary-900 dark:text-gray-200 right-2 absolute-center-y" }, {
                    default: _withCtx(() => [
                        (__props.search === '')
                            ? (_openBlock(), _createBlock(SvgIcon, {
                                key: 0,
                                name: "search"
                            }))
                            : (_openBlock(), _createElementBlock("button", {
                                key: 1,
                                onClick: cancelSearch
                            }, [
                                _createVNode(SvgIcon, { name: "search-cross" })
                            ]))
                    ], undefined, true),
                    _: 1
                })
            ]));
        };
    }
});
